var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      attrs: { hover: "" },
      nativeOn: {
        click: function ($event) {
          return _vm.showDetail()
        },
      },
    },
    [
      _c("v-progress-linear", {
        staticStyle: { margin: "0" },
        attrs: {
          color: _vm.lavorazione.progresso < 100 ? "info" : "success",
          height: "5",
          value: _vm.lavorazione.progresso,
        },
      }),
      _c(
        "v-avatar",
        { staticClass: "ico-stato", attrs: { size: "40" } },
        [
          _c(
            "v-icon",
            {
              class: [
                _vm.iconClassByProgress(_vm.lavorazione),
                "lighten-1",
                "white--text",
              ],
            },
            [
              _vm._v(
                _vm._s(_vm._f("statoLavorazioneIco")(_vm.lavorazione.stato))
              ),
            ]
          ),
        ],
        1
      ),
      _vm.lavorazione.note && _vm.lavorazione.note.length > 0
        ? _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-icon",
                {
                  staticClass: "ico-stato",
                  attrs: {
                    slot: "activator",
                    size: "40",
                    color: "yellow darken-1",
                    dark: "",
                  },
                  slot: "activator",
                },
                [_vm._v("mdi-note")]
              ),
              _c("span", [_vm._v(_vm._s(_vm.lavorazione.note))]),
            ],
            1
          )
        : _vm._e(),
      _c("v-card-text", [
        _c("h3", { staticClass: "headline mb-0" }, [
          _vm._v(_vm._s(_vm.lavorazione.codiceLAK)),
        ]),
        !_vm.compact
          ? _c("div", { staticClass: "text-truncate" }, [
              _vm._v("ORDINE N. "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.lavorazione.ordineNumero) +
                    " / " +
                    _vm._s(_vm.lavorazione.ordineLinea)
                ),
              ]),
              _vm._v(" DEL "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataOrdine))
                ),
              ]),
            ])
          : _vm._e(),
        !_vm.compact
          ? _c("div", { staticClass: "text-truncate" }, [
              _vm._v("STAGIONE: "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.lavorazione.stagione &&
                      `${_vm.lavorazione.stagione.id} ${_vm.lavorazione.stagione.descrizione}`
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("FASE: "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.lavorazione.fase &&
                  `${_vm.lavorazione.fase.id} ${_vm.lavorazione.fase.descrizione}`
              )
            ),
          ]),
        ]),
        !_vm.compact && _vm.lavorazione.lineaVendita
          ? _c("div", { staticClass: "text-truncate" }, [
              _vm._v("LINEA VENDITA: "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.lavorazione.lineaVendita &&
                      `${_vm.lavorazione.lineaVendita.id} ${_vm.lavorazione.lineaVendita.descrizione}`
                  )
                ),
              ]),
            ])
          : _vm._e(),
        !_vm.compact
          ? _c("div", { staticClass: "text-truncate" }, [
              _vm._v("MODELLO: "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.lavorazione.modello &&
                      `${_vm.lavorazione.modello.codiceParte} ${_vm.lavorazione.modello.descrizione}`
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("COLORE: "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.lavorazione.colore &&
                  `${_vm.lavorazione.colore.codiceColore} ${_vm.lavorazione.colore.descrizione}`
              )
            ),
          ]),
        ]),
      ]),
      _c("v-card-text", [
        _c("div", [
          _vm._v("NUMERO CAPI: "),
          _c("strong", [_vm._v(_vm._s(_vm.lavorazione.qtaTotale))]),
        ]),
        _c("div", [
          _vm._v("LOTTO: "),
          _c("strong", [_vm._v(_vm._s(_vm.lavorazione.lotto))]),
          _vm._v(" CONSEGNA: "),
          _c("strong", [_vm._v(_vm._s(_vm.lavorazione.codiceConsegna))]),
        ]),
        _c("div", [
          _vm._v("DATA SCADENZA: "),
          _c("strong", [
            _vm._v(_vm._s(_vm._f("formatDate")(_vm.lavorazione.dataConsegna))),
          ]),
        ]),
        !_vm.compact
          ? _c("div", [
              _vm._v("DATA ORDINE: "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataOrdine))
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.lavorazione.datiAggiuntivi &&
      _vm.lavorazione.datiAggiuntivi.length > 0
        ? _c(
            "v-card-text",
            _vm._l(_vm.lavorazione.datiAggiuntivi, function (da, i) {
              return da.value
                ? _c(
                    "v-chip",
                    {
                      key: da.name,
                      class: [
                        _vm.getChipColorByHashedString(da.name),
                        "lighten-3",
                      ],
                      staticStyle: {
                        "margin-right": "0.25rem",
                        "margin-bottom": "0.2rem",
                      },
                      attrs: { label: "", small: "" },
                    },
                    [
                      _vm._v(" " + _vm._s(da.displayName) + ": "),
                      da.metadataType == _vm.metadataType.Datetime
                        ? _c("strong", [
                            _vm._v(_vm._s(_vm._f("formatDate")(da.value))),
                          ])
                        : _c("strong", [_vm._v(_vm._s(da.value))]),
                    ]
                  )
                : _vm._e()
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }